module.exports = __webpack_public_path__ + "img/accounting.96c94ba8.svg";